import React from 'react';
import PropTypes from 'prop-types';
import { List, Checkbox } from 'semantic-ui-react';

export default function RateCheckbox({ rate, onRateChecked, ratesChecked, className }) {
    let classContent = 'rate-style ';

    return (
        <List.Item className={className}>
            <List.Content className={classContent}>
                <Checkbox label={rate.name} checked={ratesChecked.includes(rate.id)} onChange={(_, { checked }) => onRateChecked(rate, checked)} />
            </List.Content>
        </List.Item>
    );
}

RateCheckbox.propTypes = {
    rate: PropTypes.object.isRequired,
    onRateChecked: PropTypes.func.isRequired,
    ratesChecked: PropTypes.array.isRequired,
    className: PropTypes.string.isRequired
};
